/*
  HALO Vídeo: vídeo de fundo em loop, sem som, com botão de pausa.

  - O vídeo só baixa quando a seção se aproxima da tela (ou logo de cara, se estiver no topo
    da página). Celular e computador podem ter arquivos diferentes; o certo é escolhido pela
    largura da tela e trocado se ela mudar.
  - Roda sozinho em loop. Para o cliente, só o botão de pausa para o vídeo. Fora da tela ou
    com a aba escondida ele também pausa, sem o cliente perceber, e volta sozinho.
  - Para quem pede menos movimento no aparelho, começa parado na capa; o botão toca.
*/
(function () {
  'use strict';

  // Streaming adaptativo (HLS) quando o navegador toca nativamente (iPhone, Android, Safari).
  var playsHls = document.createElement('video').canPlayType('application/vnd.apple.mpegurl') !== '';


  if (!window.customElements || customElements.get('halo-video')) return;

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  class HaloVideo extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-hv-toggle]');
      if (!this.video) return;
      this.started = true;

      this.ac = new AbortController();
      var on = { signal: this.ac.signal };
      var self = this;

      this.userPaused = reduceQuery.matches;
      this.inView = false;
      this.updateToggle();

      this.video.addEventListener('playing', function () {
        self.video.classList.add('is-ready');
      }, on);

      if (this.toggle) {
        this.toggle.addEventListener('click', function () {
          self.userPaused = !self.userPaused;
          self.updateToggle();
          if (!self.userPaused) self.load();
          self.sync();
        }, on);
      }

      if (this.hasAttribute('data-eager')) this.load();

      // Perto da tela: baixa. Na tela: toca.
      this.near = new IntersectionObserver(function (entries) {
        if (entries[entries.length - 1].isIntersecting) self.load();
      }, { rootMargin: '400px 0px' });
      this.near.observe(this);
      this.io = new IntersectionObserver(function (entries) {
        self.inView = entries[entries.length - 1].isIntersecting;
        self.sync();
      }, { threshold: 0.1 });
      this.io.observe(this);

      document.addEventListener('visibilitychange', this.sync.bind(this), on);
      mobileQuery.addEventListener('change', function () {
        if (self.video.getAttribute('src')) self.load(true);
        self.sync();
      }, on);
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      this.ac.abort();
      if (this.near) this.near.disconnect();
      if (this.io) this.io.disconnect();
      if (this.video) this.video.pause();
    }

    source() {
      var data = this.video.dataset;
      var isMobile = mobileQuery.matches;
      if (playsHls) {
        var hls = isMobile && data.hlsMobile ? data.hlsMobile : data.hlsDesktop;
        if (hls) return hls;
      }
      return isMobile && data.srcMobile ? data.srcMobile : data.srcDesktop;
    }

    load(force) {
      var src = this.source();
      if (!src) return;
      if (!force && this.video.getAttribute('src')) return;
      if (this.video.getAttribute('src') === src) return;
      this.video.classList.remove('is-ready');
      this.video.setAttribute('src', src);
      this.video.muted = true;
    }

    sync() {
      var play = this.inView && !this.userPaused && !document.hidden;
      if (play) {
        this.load();
        this.video.muted = true;
        var played = this.video.play();
        if (played && played.catch) played.catch(function () {});
      } else if (!this.video.paused) {
        this.video.pause();
      }
    }

    updateToggle() {
      if (!this.toggle) return;
      this.toggle.dataset.state = this.userPaused ? 'paused' : 'playing';
      var label = this.userPaused ? this.dataset.labelPlay : this.dataset.labelPause;
      if (label) this.toggle.setAttribute('aria-label', label);
    }
  }

  customElements.define('halo-video', HaloVideo);
})();
